import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LinxLogo from "../assets/linx-logo.svg";
import HomeImage from "../assets/Home/scroll-world-concepts/scene-01-the-connection.png";
import AboutImage from "../assets/Home/scroll-world-concepts/scene-02-ideas-begin-with-people.png";
import ServicesImage from "../assets/Home/scroll-world-concepts/scene-03-consulting-find-the-right-path.png";
import WorkImage from "../assets/Home/scroll-world-concepts/scene-06-proof-in-the-field.png";
import VenturesImage from "../assets/Home/scroll-world-concepts/scene-07-we-build-our-own-ideas.png";
import { SITE_ORIGIN, buildPageMetadata, getRoute } from "./siteMetadata.mjs";

const pageImages = {
    "/": HomeImage,
    "/about": AboutImage,
    "/services": ServicesImage,
    "/work": WorkImage,
    "/ventures": VenturesImage,
    "/contact": HomeImage,
    "/privacy": HomeImage,
    "/security": HomeImage,
    "/terms": HomeImage,
};

function absoluteAssetUrl(assetUrl) {
    if (/^https?:\/\//.test(assetUrl)) return assetUrl;
    return `${SITE_ORIGIN}${assetUrl.startsWith("/") ? "" : "/"}${assetUrl}`;
}

function addElement(tagName, attributes, textContent) {
    const element = document.createElement(tagName);
    element.setAttribute("data-linx-metadata", "true");

    Object.entries(attributes).forEach(([name, value]) => {
        element.setAttribute(name, String(value));
    });

    if (textContent) element.textContent = textContent;
    document.head.appendChild(element);
}

function renderMetadata(metadata) {
    document.head.querySelectorAll("[data-linx-metadata]").forEach((element) => element.remove());

    addElement("title", {}, metadata.title);
    addElement("meta", { name: "description", content: metadata.description });
    addElement("meta", { name: "robots", content: metadata.robots });
    addElement("link", { rel: "canonical", href: metadata.url });

    addElement("meta", { property: "og:site_name", content: "Linx Systems" });
    addElement("meta", { property: "og:locale", content: "en_US" });
    addElement("meta", { property: "og:type", content: "website" });
    addElement("meta", { property: "og:title", content: metadata.title });
    addElement("meta", { property: "og:description", content: metadata.description });
    addElement("meta", { property: "og:url", content: metadata.url });
    addElement("meta", { property: "og:image", content: metadata.image });
    addElement("meta", { property: "og:image:secure_url", content: metadata.image });
    addElement("meta", { property: "og:image:width", content: metadata.imageWidth });
    addElement("meta", { property: "og:image:height", content: metadata.imageHeight });
    addElement("meta", { property: "og:image:alt", content: metadata.imageAlt });

    addElement("meta", { name: "twitter:card", content: "summary_large_image" });
    addElement("meta", { name: "twitter:title", content: metadata.title });
    addElement("meta", { name: "twitter:description", content: metadata.description });
    addElement("meta", { name: "twitter:image", content: metadata.image });
    addElement("meta", { name: "twitter:image:alt", content: metadata.imageAlt });

    addElement(
        "script",
        { type: "application/ld+json", id: "linx-structured-data" },
        JSON.stringify(metadata.graph).replace(/</g, "\\u003c"),
    );
}

export default function PageMetadata() {
    const location = useLocation();

    useEffect(() => {
        const route = getRoute(location.pathname) || getRoute("/");
        const metadata = buildPageMetadata(
            route.path,
            {
                logo: absoluteAssetUrl(LinxLogo),
                image: absoluteAssetUrl(pageImages[route.path]),
            },
            new Date().getFullYear(),
        );

        renderMetadata(metadata);
    }, [location.pathname]);

    return null;
}
